import axios from 'axios'

import { SendEventRequestInterface, SendEventResponseInterface } from '../Interfaces/SendEventInterface'
import { getRequestConfig } from './index'

export async function sendEvent(
  estimateId: number,
  data: SendEventRequestInterface,
): Promise<SendEventResponseInterface> {
  const url = `/rest-invoice/api/estimates/${estimateId}/sendevent`
  const response = await axios.post(url, data, getRequestConfig())
  return response.data
}

export async function deleteEstimateEvent(
  estimateId: number,
  data: SendEventRequestInterface,
): Promise<SendEventResponseInterface> {
  const url = `/rest-invoice/api/estimates/${estimateId}/deleteevent`
  const response = await axios.post(url, data, getRequestConfig())
  return response.data
}
